import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';

const QuoteProductListDetails = () => {
  const columns = [
    { label: 'Name', value: 'name' },
    { label: 'SKU', value: 'sku' },
    { label: 'Unit Price', value: 'unit_price' },
    { label: 'Access Details', value: (id) => <button onClick={() => handleAccessDetails(id)}>Access Details</button> },
  ];
  const handleAccessDetails = (id) => {
    const encodedId = btoa(id);
    window.location.href = '/quote/product/details/' + encodedId;
  };
  return <ListTemplate columns={columns} onAccessDetails={handleAccessDetails} fetchUrl={API_DOMAIN + API_ROUTES['quoteProduct']} />;
};

export default QuoteProductListDetails;
